module.exports = __webpack_public_path__ + "img/survey_meeting.86899876.jpg";